"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Component = function (p) { return (Preact.h(Box_1.default, { sx: { background: 'black', color: 'white', opacity: 0.6, p: 3 } },
    Preact.h(Typography_1.default, null, p.file.name),
    Preact.h(Typography_1.default, null,
        (p.file.sizeBytes / 1024 / 1024).toFixed(2),
        "MB"),
    Preact.h(Typography_1.default, { sx: { mt: 3 } },
        "Polycount: ",
        p.model.polygons,
        " polygons"),
    Preact.h(Typography_1.default, null,
        "Bounding Box Dimensions(width(x):",
        p.model.boundingBoxDimensions.width.toFixed(2),
        ", height(y):",
        p.model.boundingBoxDimensions.height.toFixed(2),
        ", depth(z):",
        ' ',
        p.model.boundingBoxDimensions.depth.toFixed(2),
        ")"),
    p.model.materialDetails.length > 0 ? (Preact.h(Typography_1.default, { sx: { mt: 3 } }, "Materials")) : null,
    p.model.materialDetails.map(function (details, i) {
        var _a;
        return (Preact.h(Box_1.default, { key: i, sx: { mt: 1 } },
            Preact.h(Typography_1.default, null, (_a = details.name) !== null && _a !== void 0 ? _a : 'Unknown',
                details.textureDimensionsPx
                    ? "  (".concat(details.textureDimensionsPx.x, "px x ").concat(details.textureDimensionsPx.y, "px)")
                    : '')));
    }))); };
exports.Component = Component;
